import { R, asFraction, toJSON, toPercentNumber } from "./rational";
import { STATUS_NREL } from "./excel-constants";

const ZERO = R(0);
const HALF = R(1, 2);

export default class FulfilmentsUtil {
  constructor() {}

  calculateRowFulfillment(row, steps) {
    if (!steps || steps.length === 0) return;
    let stepsLength = steps.length;
    let closedCount = ZERO;
    let wipCount = ZERO;
    let nrelCount = 0;

    steps.forEach((step) => {
      closedCount = row[step.identity] === "closed" ? closedCount.add(1) : closedCount;
      wipCount = row[step.identity] === "wip" ? wipCount.add(HALF) : wipCount;
      nrelCount += row[step.identity] === "n.rel." ? 1 : 0;
    });

    const effectiveStepsLength = stepsLength - nrelCount;

    if (nrelCount === stepsLength) {
      row.fulfillment = "n.rel.";
      return;
    }

    const fulfillment = closedCount.add(wipCount).div(R(effectiveStepsLength));
    row.fulfillment = toJSON(fulfillment);
  }

  recalculateAllFulfillments(deliverables, steps) {
    const traverse = (item) => {
      if (!item) return;
      const children = Array.isArray(item.children) ? item.children : [];
      if (children.length > 0) {
        children.forEach(traverse);
        const weightSum = children.reduce((sum, child) => sum.add(asFraction(child.weight)), ZERO);
        item.weight = toJSON(weightSum);
        this.calculateParentSteps(item, steps);
        this.calculateParentFulfillment(item, steps);
      } else {
        // Normalize leaf weight shape
        item.weight = toJSON(asFraction(item.weight));
        this.calculateRowFulfillment(item, steps);
      }
    };

    if (Array.isArray(deliverables)) {
      deliverables.forEach(traverse);
    }
  }

  collectLeaves(node) {
    if (!node) return [];
    const children = Array.isArray(node.children) ? node.children : [];
    if (children.length === 0) {
      return [node];
    }
    return children.reduce((acc, child) => acc.concat(this.collectLeaves(child)), []);
  }

  calculateParentSteps(row, steps) {
    if (!steps || steps.length === 0) return;
    const leaves = this.collectLeaves(row).filter((leaf) => leaf !== row);
    steps.forEach((step) => {
      let totalWeights = ZERO;
      let wipCount = ZERO;
      let closedCount = ZERO;

      leaves.forEach((item) => {
        const weight = asFraction(item.weight);
        if (item[step.identity] !== "n.rel.") {
          totalWeights = totalWeights.add(weight);
        }
        closedCount = item[step.identity] === "closed" ? closedCount.add(weight) : closedCount;
        wipCount = item[step.identity] === "wip" ? wipCount.add(weight.mul(HALF)) : wipCount;
      });

      if (totalWeights.equals(0)) {
        row[step.identity] = STATUS_NREL;
        return;
      }

      const fulfillment = closedCount.add(wipCount).div(totalWeights);
      row[step.identity] = toPercentNumber(fulfillment);
    });
  }

  calculateParentFulfillment(row, steps) {
    if (!steps || steps.length === 0) return;
    const leaves = this.collectLeaves(row).filter((leaf) => leaf !== row);
    let totalWeights = ZERO;
    let sumAll = ZERO;

    leaves.forEach((item) => {
      if (item.fulfillment === "n.rel.") return;
      const weight = asFraction(item.weight);
      const fulfillment = asFraction(item.fulfillment);
      totalWeights = totalWeights.add(weight);
      sumAll = sumAll.add(fulfillment.mul(weight));
    });

    row.fulfillment = totalWeights.equals(0) ? toJSON(ZERO) : toJSON(sumAll.div(totalWeights));
  }
}
